<template>
  <TopBarShell class="content-owner-top-bar" data-testid="content-owner-top-bar">
    <template #actions>
      <OcrSelectionToolbar v-if="isImage && ocrEnabled" :show-processing="ocrFeatureEnabled" />

      <button
        v-if="isImage && !isGif"
        class="content-owner-top-bar__icon-btn"
        title="Annotate"
        aria-label="Annotate"
        :disabled="isEditProcessing"
        data-testid="viewer-topbar-annotate"
        @click="!isEditProcessing ? annotateAction() : undefined"
      >
        <Icon name="general.pencil" size="base" />
      </button>

      <TopBarActions />
    </template>
  </TopBarShell>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook';

import TopBarShell from '../../shared/TopBarShell.vue';
import TopBarActions from '../../shared/TopBarActions.vue';
import OcrSelectionToolbar from '../../shared/OcrSelectionToolbar.vue';

import { useViewerItemStore, ItemType } from '@/modules/viewer/store/useViewerItemStore';
import { useItemActions } from '@/modules/viewer/composables/useItemActions';
import { useFeatures } from '@/composables/useFeatures';
import { useEntitlementsStore } from '@/store/useEntitlementsStore';

const viewerItemStore = useViewerItemStore();
const { isEditProcessing, isGif, type } = storeToRefs(viewerItemStore);
const { annotateAction } = useItemActions();
const { getItemFeature } = useFeatures();
const ocrFeatureEnabled = getItemFeature('image-ocr-enabled', false);
const ocrEnabled = computed(() => useEntitlementsStore().can('ocr'));

const isImage = computed(() => type.value === ItemType.IMAGE);
</script>

<style scoped>
.content-owner-top-bar {
  @apply pb-2;
}

.content-owner-top-bar__icon-btn {
  @apply p-2 rounded-md text-zinc-600 dark:text-zinc-400 hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
